export const AppInsightsConstants = {
    Role: "SSE-WebAddinUI",
    Product: "SafeSend Exchange",
};

export const reportProblemConstants = {
    TITLE: "Report a Problem",
    PRODUCT_TYPE_LABEL: "Product Type",
    PRODUCT_TYPE_PLACEHOLDER: "Exchange",
    CPA_FIRM_LABEL: "CPA Firm",
    PHONE_LABEL: "Phone",
    USER_LABEL: "Logged in User",
    EMAIL_LABEL: "Email",
    DESCRIPTION_LABEL: "Description",
    ATTACHMENT_LABEL: "Add Attachment",
    EMPTY_ERROR_MESSAGE: "This field can't be empty",
    INVALID_EMAIL_ERROR_MESSAGE: "Email is invalid",
    MAXIMUM_FILE_SIZE: "15728640",
    FILE_SIZE_ERROR_MESSAGE: "Upload failed. Please attach file less than 15 MB.",
    SUPPOERTED_FILE_FORMATE: ".png, .jpg, .jpeg, .doc, .docx, .pdf",
    ATTACHMENT_INFO_TEXT: "Maximum file size 15MB; Allowed file types: jpeg, jpg, png, doc, docx and pdf",
    SEND_REMINDER_SPECIFIC_FILE: "Document reminder sent successfully.",
};

export enum ProductType {
    None = 0,
    Returns = 1,
    SignaturesOneOff = 2,
    SignaturesMailMerge = 3,
    Organizers = 4,
    Extensions = 5,
    Exchange = 6,
    SSSuitePortal = 1001,
}

export const reportAttachmentFormats = ["png", "jpg", "jpeg", "doc", "docx", "pdf"];

export const dialogRoutes = ["Admin Settings", "Unlock", "Sent Messages", "Received Messages", "Document Requests"];

export const notAvailableRoutes = ["Drafts"];

export const restrictedMenuItemCaptions = ["Settings", "History Reports", "Drafts"];

export const SideMenuConstants = {
    ADMIN_SETTINGS: "Settings",
    HELP: "Help",
    MESSAGE_HISTORY: "History Reports",
    UNLOCK: "Unlock",
    REQUEST_DOCUMENTS: "Request Documents",
};

export const ShareFolderTypeLabels = {
    VIEW: "view",
    EDIT: "edit",
    REMOVE: "remove",
};
export const AdminSettingsConstants = {
    GENERAL_SETTING_TITLE: "General Settings",
    DROPOFF_SETTING_TITLE: "Drop Off Settings",
    REPORT_SETTING_TITLE: "History Report Settings",
    NOTIFICATION_SETTING_TITLE: "Notification Settings",
    DOCUMENT_REQUEST_SETTING_TITLE: "Document Request Settings",
    EMAIL_TEMPLATE_SETTING_TITLE: "Email Notification Template",
};
export const SettingConstants = {
    GENERAL: "General",
    DROPOFF: "Drop Off",
    REPORT: "History",
    NOTIFICATION: "Notifications",
    DOCUMENT_REQUEST: "Document Request",
    EMAIL_TEMPLATE_TITLE :"Email Template",
};

export const TabConstants = {
    GENERAL_MESSAGE_OPTIONS: "Message Options",
    GENERAL_SUPPORT_CONTACT: "Support Contact",
    GENERAL_AUTHENTICATION_QUESTIONS: "Authentication Questions",
    DROPOFF_CONFIGURATION: "Configuration",
    DROPOFF_USERS: "Users",
    REPORT_MESSAGE_HISTORY: "Message History",
    REPORT_REQUEST_HISTORY: "Request History",
    NOTIFICATION_MESSAGE: "Message Notifications",
    NOTIFICATION_REQUEST: "Request Notifications",
    DOCUMENT_REQUEST_CATEGORY: "Document Category",
    DOCUMENT_REQUEST_TEMPLATE: "Request Templates",
    EMAIL_TEMPLATE_SECURE_MESSAGE: "Message Email Template",
    EMAIL_TEMPLATE_REQUESTS: "Request Email Template",
    NOTIFICATION_FOLDER: "Folder Notifications",    
};

export const SavedMessageEmailTemplate = {
    BASE_TEMPLATE_NAME: "BaseTemplate",
    MESSAGE_EMAILTEMPLATE_HEADER :"New Message Email Template",
    MESSAGE_EMAILTEMPLATE_HELPER_TEXT: "Manage email templates for Compose Message notifications.",
    REQUEST_EMAILTEMPLATE_HEADER :"New Request Email Template",
    REQUEST_EMAILTEMPLATE_HELPER_TEXT: "Manage email templates for Request Message notifications.",
    ALLOW_TO_SET_DEFAULT_Template: "isUserAllowedToChangeSecureMailTemplate",
    ALLOW_TO_SET_DEFAULT_DR_Template: "isUserAllowedToChangeDRMailTemplate",
    ALLOW_TO_CHANGE_DEFAULT_Template_TEXT: "Allow Users to change default template.",
    ALLOW_TO_ADD_NEW_Template: "isUserAllowedToAddSecureMailTemplate",
    ALLOW_TO_ADD_NEW_DR_Template: "isUserAllowedToAddDRMailTemplate",
    ALLOW_TO_ADD_NEW_Template_TEXT: "Allow Users to add their own templates.",
    ADD_TEMPLATE_TITLE : "Add New Template",
    EDIT_TEMPLATE_MODAL_HEADER : "Edit Message Email Template",
    EDIT_REQUEST_TEMPLATE_MODAL_HEADER : "Edit Request Email Template",
    ADD_TEMPLATE_MODAL_HEADER : "Add Message Email Template",
    ADD_REQUEST_TEMPLATE_MODAL_HEADER : "Add Request Email Template",
    MODAL_NAME_INPUT_LABEL:"Template Name",
    MODAL_NAME_MESSAGE_INPUT_LABEL:"Message",
    MAX_TEMPLATE_NAME_LENGTH: 100,
    NAME_REQUIRED_TEXT: "Template name is required",
    MESSAGE_REQUIRED_TEXT: "Message is required",
    SYSTEM_DEFAULT_HOVER_TEXT: "System default template cannot be modified",
    CLICK_TO_COPY_TEXT: "Click to copy",
    TEMPLATE_CREATED_SUCCESS: "Email Template added successfully.",
    TEMPLATE_UPDATED_SUCCESS: "Email Template updated successfully.",
    TEMPLATE_DELETED_SUCCESS: "Email Template deleted successfully.",
    TEMPLATE_EXIST_MESSAGE: "This Template already exists",
    DUPLICATE_TEMPLATE_NOTIFICATION:"Template Name already exists.",
    CONFIRM_ADD_BUTTON :"Add",
    CONFIRM_SAVE_BUTTON:"Save",
    CANCEL_BUTTON :"Cancel",
    DELETE_TEMPLATE_MODAL_TITLE: "Delete Template",
    DELETE_TEMPLATES_MODAL_TEXT: "Do you want to delete the selected Email Template?",
    EMAIL_TEMPLATE_TITLE: "Email Notification Template",
    MESSAGE_EMAILTEMPLATE_HELPER_TEXT_USER_SETTINGS: "Manage email templates for Message notifications.",
    TEMPLATE_NOT_DELETEABLE: "System default template cannot be deleted",
    ADMIN_TEMPLATE_NOT_DELETEABLE: "Admin template cannot be deleted",
    ACTION_DISABLED:"Action on this template is restricted",
    ADD_BUTTON_TOOL_TIP:"Add New Template",
    CHANGE_DEFAULT_TEMPLATE_METHOD_WARNING_TEXT:"Turning this off will revert all user's saved message to the company default. Do you wish to continue?",
};

export const SavedMessageVariableList = {
    SenderName: "The name of the user that has sent the message or request list.",
    CompanyName: "The name of the company on your account.",
    ExpiryDate: "The date the message will expire at time of delivery.",
};

export const FolderNotificationConstants = {
    FOLDER_NOTIFICATION_ACCORDION_HEADER: "Folder Notifications",
    NEW_MESSAGES: "New Items",
    FOLDER_NOTIFICATION_HELPER_TEXT: "Manage notifications for Folders.",
    FOLDER_NOTIFICATION_NEW_MESSAGE_HELPER_TEXT:
        "Choose if users will receive new item notifications.",
    FOLDER_NOTIFICATION_NOTIFY_FOR_FOLDER_INCOMING_MESSAGES: "Notify CPA when new items are added to a folder",
    IS_USER_ALLOWED_TO_CHANGE_FOLDER_NOTIFICATION_TEXT : "Allow employees to update their new item notification setting",
    IS_FOLDER_NOTIFICATION_ENABLED: "isFolderNotificationEnabled",
    IS_USER_ALLOWED_TO_CHANGE_FOLDER_NOTIFICATION : "isUserAllowedToChangeFolderNotification",
    CONFIRM_DISABLE_FOLDER_NOTIFICATIONS : "Turning off this setting will disable all folder notifications across the firm. Do you want to continue?",
    CONFIRM_ENABLE_FOLDER_NOTIFICATIONS : "Turning this setting ON will restore folder notifications across the firm to their last saved state. Do you want to continue?",
    ENABLE_NOTIFICATIONS: "Enable Notifications",
    IS_FOLDER_NOTIFICATION_ACTIVE: "isFolderNotificationActive",
};

export const DefaultTaxYearConstants={
    DEFAULT_Tax_YEAR_TITLE:"Default Tax Year",
    DEFAULT_Tax_YEAR__HELPER_TEXT_USER_SETTINGS: "Set the default tax year to apply when sending new messages and requesting documents.",
    DEFAULT_Tax_YEAR_PLACEHOLDER_TEXT: "Select Default Tax Year",
    Tax_YEAR_PLACEHOLDER_TEXT: "Select Tax Year",
    DEFAULT_TAX_YEAR_LOWER_LIMIT: 2021
};